import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  children: PropTypes.node.isRequired,
  addContentWrap: PropTypes.bool,
  className: PropTypes.string,
};

const Header = ({ children, className, addContentWrap }) => {
  const classes = classNames({
    'header-main': true,
    [className]: !!className,
  });

  if (addContentWrap) {
    return (
      <header className={classes}>
        <div className="header-main-wrap">{children}</div>
      </header>
    );
  }

  return <header className={classes}>{children}</header>;
};

Header.propTypes = propTypes;

export default Header;
